import ArrowTooltip from "components/elements/Tooltips/ArrowTooltip";

/**
 * Tooltip for a toolbar control, styled to match the side nav tooltips. Opens
 * above by default; controls along the top of the viewer open it below.
 *
 * Tooltips in the top bars wait a little longer before opening, so moving
 * across a row of tabs to click one doesn't flash a tooltip on each.
 */
export default function ToolbarTooltip(
  p: Readonly<{
    label: string;
    placement?: "top" | "bottom";
    isDisabled?: boolean;
    children: React.JSX.Element;
  }>,
) {
  return (
    <ArrowTooltip
      label={p.label}
      placement={p.placement}
      openDelay={p.placement === "bottom" ? 1000 : 900}
      isDisabled={p.isDisabled}
    >
      {p.children}
    </ArrowTooltip>
  );
}
